export {
  TeachersWebFeature,
  teachersWebFeature,
  TeachersWebFeature as default,
} from './TeachersWebFeature'
export * from './types'
